const mutations = {
  setCategories(state, data) {
    state.categories = data;
  },
  setSubcategories(state, data) {
    state.subcategories = data;
  },
  setJobs(state, data) {
    state.jobs = data;
  },
  setVendorList(state, data) {
    state.vendors = data;
  },
  setAdminUser(state, data) {
    state.adminUser = data;
  }
}

export default mutations;
